import React from "react";
import { Alert } from "antd";
import PropTypes from "prop-types";

const ErrorMsg = ({ message, description }) => {
  return (
    <Alert
      style={{ marginTop: "8px", marginBottom: "8px" }}
      type={"warning"}
      message={message}
      description={description}
      showIcon={true}
    />
  );
};

ErrorMsg.propTypes = {
  message: PropTypes.string.isRequired,
  description: PropTypes.string
};

export default ErrorMsg;



// WEBPACK FOOTER //
// ./src/components/error_msg/ErrorMsg.jsx